import { BaseEntity, BaseSearchForm } from 'entities'
import { HasAddress } from './address'
import { Institution } from './institution'

export type Patient = BaseEntity &
    HasAddress & {
        code?: string
        familyName?: string
        givenName?: string
        familyNameKana?: string
        givenNameKana?: string
        searchName?: string
        gender?: string
        email?: string
        tel?: string
        birthday?: string
        institution?: Institution
        institutionId?: number
        addressId?: number
        sampleCount?: number
    }

export type PatientForm = Patient & {
    patientId?: number
    isDuplicateChecked?: boolean
}

export type PatientSearchForm = BaseSearchForm & {
    name?: string
    id?: string
    familyNameKana?: string
    givenNameKana?: string
    birthdayEq?: string
    gender?: string
}

export const GENDER = ['MALE', 'FEMALE']
export const GENDER_JP = ['男性', '女性']
export const GENDER_SELECT_ITEM = GENDER.map((v, index) => {
    return { label: GENDER_JP[index], value: v }
})
